import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { ReactNode } from 'react';

import { Icon, IconType } from '@shared/ui/components/Icon';
import { cn } from '@shared/utils/helpers';
import { PropsWithClassName } from '@shared/utils/types';

type ContextSelectorProps<T> = PropsWithClassName<{
  selected: T;
  options: T[];
  icon: IconType;
  label: (option: T) => ReactNode;
  onSelect: (event: T) => void;
}>;

export function ContextSelector<T>({ selected, options, label, icon, className, onSelect }: ContextSelectorProps<T>) {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        className={cn(
          'outline-none cursor-pointer w-full lg:w-auto flex items-center gap-3 bg-white border hover:bg-gray-50 data-[state=open]:bg-gray-50 rounded px-3 py-1.5 text-gray-400',
          className
        )}
      >
        <Icon icon={icon} className="text-gray-500 text-xl" />
        <span className="text-gray-700 font-normal whitespace-nowrap truncate">{label(selected)}</span>
        <Icon icon="angle-down" className="ml-auto text-gray-400" />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="bg-white rounded z-dropdown overflow-hidden mt-1 py-1 shadow-xl border border-gray-100"
          align="start"
        >
          {options.map((item, index) => (
            <DropdownMenu.Item
              key={index}
              className="outline-none cursor-pointer flex items-center gap-3 pl-3 pr-6 py-2 group text-gray-400"
              onClick={() => onSelect(item)}
            >
              <Icon icon={icon} className="text-gray-400 text-xl" />
              <span className="text-gray-700 font-normal group-hover:text-indigo-700">{label(item)}</span>
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
